export enum Navigation {
  DETAILS = "Details",
  RUN = "Test the extract",
  RULES = "Configuration",
  SCHEDULING = "Schedule",
  VERSIONING = "Versioning",
  QA = "Execute",
  OUTPUT = "Output config",
  OPTOUT = "Optout",
  RESULTS = "Results"
}

export const ExtractDetailMenus = [
  Navigation.DETAILS,
  Navigation.OUTPUT,
  Navigation.SCHEDULING,
  Navigation.VERSIONING,
  Navigation.QA,
  Navigation.OPTOUT,
  Navigation.RESULTS
];

export interface ExtractDetailSelectedTab {
  extractId: string;
  selectedTab: Navigation;
}
